import React from 'react';
import { Calendar, List, Calendar as CalendarIcon, Target, Eye, BookOpen, History } from 'lucide-react';

export type ViewType = 'day' | 'week' | 'month' | 'year' | 'timeline' | 'list' | 'calendar';

interface ViewTabsProps {
  activeView: ViewType;
  onViewChange: (view: ViewType) => void;
}

export const ViewTabs: React.FC<ViewTabsProps> = ({ activeView, onViewChange }) => {
  const tabs = [
    { id: 'day' as ViewType, label: 'Day', icon: BookOpen },
    { id: 'week' as ViewType, label: 'Week', icon: CalendarIcon },
    { id: 'month' as ViewType, label: 'Month', icon: Calendar },
    { id: 'year' as ViewType, label: 'Year', icon: Target },
    { id: 'timeline' as ViewType, label: 'Timeline', icon: History },
    { id: 'list' as ViewType, label: 'All Tasks', icon: List },
    { id: 'calendar' as ViewType, label: 'Calendar', icon: Eye },
  ];

  return (
    <div className="flex space-x-1 bg-gray-100 p-1 rounded-lg overflow-x-auto">
      {tabs.map(({ id, label, icon: Icon }) => (
        <button
          key={id}
          onClick={() => onViewChange(id)}
          className={`flex items-center justify-center sm:justify-start px-3 sm:px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap min-w-0 flex-1 sm:flex-none ${
            activeView === id
              ? 'bg-white text-blue-600 shadow-sm'
              : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
          }`}
        >
          <Icon className="w-4 h-4 sm:mr-2" />
          <span className="hidden sm:inline ml-0 sm:ml-0">{label}</span>
        </button>
      ))}
    </div>
  );
}; 